import Vue from 'vue';
import modelRenameComponent from 'rrViewComponents/Model/Rename/ModelRenameComponent/sw-model-rename.vue';

export default function ($fragment) {
    $fragment.swFindWithSelf('[data-sw-model-rename]').each(function () {
        var el = this;

        new Vue({
            el: el,
            components: {
                'sw-model-rename': modelRenameComponent
            }
        });

    });
}
